import { useCallback } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS, REPORT_STATUS, TIME_OUT_STATUS } from "@constants"
import { reportSearchSummaryID } from "Pages/Main/Home/@signals"


export default function useReportSearchSummary(idReport, rowData) {
	const sites = rowData.sitesName || []
	const totalSiteSearch = 100
	const totalOfficeSearch = 100
	const pickUps = rowData.pickUp || []

	const isRunning = rowData.statusLastExecution === REPORT_STATUS.RUNNING
	const isLoadingSiteSearchSummary = useSignal(isRunning)
	const isLoadingOfficeSearchSummary = useSignal(isRunning)
	const siteSearchSummary = useSignal([])
	const officeSearchSummary = useSignal([])
	const completedSiteSearches = useSignal(0)
	const completedOfficeSearches = useSignal(0)

	const getStatus = useCallback(() => {
		if (isRunning) {
			postSubmit(`${BACKEND_APIS.EXECUTION_INFO}/status-per-site`, {
				idReportExecution: rowData.idLastExecution
			}).then(({ globalData, statusData }) => batch(() => {
				siteSearchSummary.value = sites.map(({ nameRaw, ...siteData }) => {
					const { percentage } = statusData[nameRaw] || {}
					return {
						...siteData,
						total: 100,
						current: percentage
					}
				})

				completedSiteSearches.value = globalData.percentage

				if (isLoadingSiteSearchSummary.value) isLoadingSiteSearchSummary.value = false
			}))
			postSubmit(`${BACKEND_APIS.EXECUTION_INFO}/status`, {
				idReportExecution: rowData.idLastExecution, perOffice: true
			}).then(({ ExecutionGlobalData, ...executionData }) => batch(() => {
				officeSearchSummary.value = pickUps.map(({ officeID, ...officeData }) => {
					const { percentage } = executionData[officeID] || {}
					return {
						...officeData,
						total: 100,
						current: percentage
					}
				})
				const globalCompleteTasks = ExecutionGlobalData.percentage
				completedOfficeSearches.value = globalCompleteTasks
				if (isLoadingOfficeSearchSummary.value) isLoadingOfficeSearchSummary.value = false
				if (globalCompleteTasks === totalOfficeSearch && completedSiteSearches.value === totalSiteSearch) {
					reportSearchSummaryID.value = null
				}
			}))

			setTimeout(() => {
				if (reportSearchSummaryID.value) getStatus()
			}, TIME_OUT_STATUS)
		}
	}, [])

	return {
		totalSiteSearch: totalSiteSearch,
		totalOfficeSearch: totalOfficeSearch,
		completedOfficeSearch: completedOfficeSearches.value,
		completedSiteSearch: completedSiteSearches.value,
		isLoadingOfficeSearchSummary: isLoadingOfficeSearchSummary.value,
		isLoadingSiteSearchSummary: isLoadingSiteSearchSummary.value,
		getStatus: getStatus,

		isMultiOffice: rowData.pickUp.length > 1,
		isOfficesRunning: isRunning,
		siteSearchSummary: siteSearchSummary.value,
		officeSearchSummary: officeSearchSummary.value
	}
}